var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_317_3598",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 58,
    height: 58
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_317_3598)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -77.7725,
    y: -17.7954,
    width: 223.432,
    height: 139.068,
    fill: "#46399D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7441 24.2561C20.7441 28.7969 24.4594 32.5121 29.0002 32.5121C33.541 32.5121 37.2563 28.7969 37.2563 24.2561C37.2563 19.7152 33.541 16 29.0002 16C24.4594 16 20.7441 19.7152 20.7441 24.2561ZM35.3137 24.2561C35.3137 27.7285 32.4726 30.5695 29.0002 30.5695C25.5278 30.5695 22.6867 27.7285 22.6867 24.2561C22.6867 20.7837 25.5278 17.9426 29.0002 17.9426C32.4726 17.9426 35.3137 20.7837 35.3137 24.2561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3841 41.3817C21.9581 38.8077 25.3576 37.3994 29 37.3994C32.6424 37.3994 36.0419 38.8077 38.6159 41.3817L40 39.9976C37.0618 37.0837 33.1523 35.4567 29 35.4567C24.8477 35.4567 20.9382 37.0837 18 39.9976L19.3841 41.3817Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile01);
export default __webpack_public_path__ + "static/media/profile-01.2ff2196f7995eb854241a82e1060e418.svg";
export { ForwardRef as ReactComponent };